import e from "react";
const a = (t) => e.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 12 12", width: "12", height: "12" }, t),
  e.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    e.createElement(
      "g",
      null,
      e.createElement("path", { d: "M811.764002,24 L815.54414,20.2198622 C816.09854,19.6654616 816.155341,18.8149273 815.67014,18.32986 C815.185073,17.8446595 814.334538,17.9014595 813.780138,18.4558602 L810,22.2359979 L806.219862,18.4558602 C805.665462,17.9014595 804.814927,17.8446595 804.32986,18.32986 C803.844659,18.8149273 803.90146,19.6654616 804.45586,20.2198622 L808.235998,24 L804.45586,27.7801378 C803.90146,28.3345384 803.844659,29.1850727 804.32986,29.67014 C804.814927,30.1553405 805.665462,30.0985405 806.219862,29.5441398 L810,25.7640021 L813.780138,29.5441398 C814.334538,30.0985405 815.185073,30.1553405 815.67014,29.67014 C816.155341,29.1850727 816.09854,28.3345384 815.54414,27.7801378 L811.764002,24", transform: "translate(-804 -18)" })
    )
  )
);
a.displayName = "X12x12";
export {
  a as I
};
//# sourceMappingURL=X12x12-BDdS6yjO.mjs.map
